import { beamApi, orderApi } from './api';

export const BEAM_METHODS = new Set(['qr_promptpay', 'credit_card']);
export const isBeamMethod = (method) => BEAM_METHODS.has(method);

const sleep = (milliseconds) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

/**
 * Cash is final at the till. Card and QR are final only after the paired Beam
 * Bolt reports success; the backend then creates the payment row exactly once.
 */
export async function takeOrderPayment({
  orderId,
  method,
  amount,
  paymentData = {},
  onWaiting,
  maxAttempts = 60,
  intervalMs = 2000,
}) {
  if (!isBeamMethod(method)) {
    return orderApi.pay(orderId, { method, amount, ...paymentData });
  }

  const created = await beamApi.createIntent(orderId, { method, amount });
  let intent = created.intent;
  onWaiting?.(intent);

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (intent.status === 'succeeded') return { success: true, intent };
    if (['failed', 'expired', 'cancelled'].includes(intent.status)) {
      throw new Error(
        intent.failureReason
          ? `Beam ชำระเงินไม่สำเร็จ: ${intent.failureReason}`
          : 'Beam ชำระเงินไม่สำเร็จ'
      );
    }

    await sleep(intervalMs);
    const checked = await beamApi.intent(intent.intentId);
    intent = checked.intent;
    onWaiting?.(intent);
    if (intent.status === 'succeeded') return checked;
  }

  throw new Error(
    'ยังไม่ได้รับผลจาก Beam กรุณาตรวจสอบเครื่อง แล้วกดชำระเงินอีกครั้งเพื่อเช็กสถานะเดิม'
  );
}
